<template>
	<div class="report">
		<div id="report" class="report__inner"></div>
		<foot-button>
			<van-button type="primary" block @click="clickDownloadPDF(getReportUrl)">保存至手机</van-button>
		</foot-button>
	</div>
</template>

<script>
	import 'pdfh5/css/pdfh5.css'
	import Pdfh5 from 'pdfh5'
	export default {
		name: 'PurchaseService',
		components: {},
		data: () => ({
			exportPDFtitle: '',
			pdfh5: null
		}),
		computed: {
			getReportUrl () {
				return decodeURIComponent(this.$route.params.url)
			}
		},
		mounted () {
			// 先实例化
			this.pdfh5 = new Pdfh5("#report", {
				pdfurl: this.getReportUrl
			})
		},
		methods: {
			clickDownloadPDF () {
				window.location.href = this.getReportUrl
			}
		}
	}
</script>

<style scoped lang="less">
	.report {
		min-height: calc(100vh - 216px);
		background-color: #fff;
	}
</style>

<style lang="less">
	.report {
		.pinch-zoom-container {
			height: initial !important;
		}
	}
</style>
